import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import GamePlayer from "@/components/GamePlayer";
import { useStudentSession } from "@/hooks/useStudentSession";
import { api } from "@/lib/api";
import type { CompleteGameSessionResult, StartGameSessionResult } from "@/types/game";

export default function StudentGamePage() {
  const nav = useNavigate();
  const { student, session, setSession } = useStudentSession();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!student) {
      nav("/student/register", { replace: true });
      return;
    }
    if (session) return;
    api.startGameSession(student.student_id)
      .then((res: StartGameSessionResult) => setSession(res))
      .catch((e) => setError(e instanceof Error ? e.message : "Could not start a game."));
  }, [student, session, nav, setSession]);

  if (error) {
    return (
      <main className="min-h-screen flex items-center justify-center p-4">
        <div className="card-dark max-w-md w-full p-6">
          <h2 className="font-display text-xl text-white">Couldn't start a game</h2>
          <p className="mt-2 text-steel-300">{error}</p>
          <button className="btn-primary mt-4 w-full" onClick={() => nav(0)}>Try again</button>
        </div>
      </main>
    );
  }
  if (!student || !session) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <div className="text-steel-300 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Preparing your run…</div>
      </main>
    );
  }

  return (
    <main className="min-h-screen px-4 py-6">
      <GamePlayer
        studentId={student.student_id}
        session={session}
        onComplete={(r: CompleteGameSessionResult) => {
          // Stash result and navigate to results screen
          sessionStorage.setItem("weldquest.lastResult", JSON.stringify(r));
          setSession(null);
          nav("/student/results");
        }}
      />
    </main>
  );
}
